import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ModalPanel, ModalSidebarContext } from '../../../../../components/ModalSidebar'
import PasswordSettingsSection from '../common/PasswordSettingsSection'
import { FIELDS_TO_VALIDATE } from '../common/PasswordSettingsSection/fieldset'

const propTypes = {
  /**
   * The auto generated password
   */
  autoGeneratedPassword: PropTypes.string.isRequired,
  /**
   * A list of label/value of all employees emails
   */
  employeeEmailOptions: PropTypes.array.isRequired, //  eslint-disable-line react/forbid-prop-types
}

function ResetPasswordPanel(props) {
  const { autoGeneratedPassword, employeeEmailOptions } = props

  const { submitForm, setTouched } = useFormikContext()

  const { nextStep, setShowValidationErrorBanner } = useContext(ModalSidebarContext)

  const onSubmitClick = async () => {
    const errors = await setTouched(FIELDS_TO_VALIDATE, true)
    if (isEmpty(errors)) {
      setShowValidationErrorBanner(false)
      submitForm()
      nextStep()
    } else {
      setShowValidationErrorBanner(true)
    }
  }

  return (
    <ModalPanel
      leftButton="cancel"
      rightButton={{
        label: 'ENGAGE.RESET_PASSWORD',
        id: 'reset-password-submit-btn',
        variant: 'primary',
        onClick: onSubmitClick,
      }}
    >
      <PasswordSettingsSection
        autoGeneratedPassword={autoGeneratedPassword}
        employeeEmailOptions={employeeEmailOptions}
        fullWidth
      />
    </ModalPanel>
  )
}

ResetPasswordPanel.propTypes = propTypes

export default ResetPasswordPanel
